import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const resumeCartAAL = Loadable(() => import('../../containers/web/resumeCartAAL'));
export default MapTo('vcg/components/soe-home/react/resumeCartAAL')(resumeCartAAL);
